/* eslint-disable react/no-danger */
/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
import React, { FC, useMemo } from 'react';
import showdown from 'showdown';
import './RenderMarkdown.style.css';

const converter = new showdown.Converter({
  openLinksInNewWindow: true,
  simplifiedAutoLink: true,
  literalMidWordUnderscores: true,
});

// Escape mid-word asterisks to prevent 12*12*12 from rendering as italic
converter.addExtension({
  type: 'lang',
  filter(text) {
    return text.replace(/(\w)\*(?=\w)/g, '$1\\*');
  },
});

converter.addExtension({
  type: 'lang',
  filter(text) {
    return text.replace(
      /(?<!\w)(?<!~)~(?!~)(?!\s)(.+?)(?<!\s)(?<!~)~(?!~)(?!\w)/g,
      '<del>$1</del>'
    );
  },
});

converter.addExtension({
  type: 'lang',
  /** Showdown previously replaces the '$' by '¨D' */
  regex: /¨D\{([\w\\_]+)\}/g,
  replace: (_: string, varName: string) =>
    `<span class="md-placeholder">${varName.replace(/\\_|_/g, '\\_')}</span>`,
});

/* Replace lists by span elements and allow arbitrary order
 */
converter.addExtension({
  type: 'lang',
  regex: /(\d+)\.\s*(.+)/g,
  replace: (_: string, order: string, content: string) => `${order}.${content}`,
});

converter.addExtension({
  type: 'lang',
  regex: /\t/g,
  replace: '',
});

converter.addExtension({
  type: 'lang',
  regex: /\r\n|\r/g,
  replace: '\n',
});

converter.addExtension({
  type: 'lang',
  filter(text) {
    return text.trim().replace(/\n/g, ' <br/>');
  },
});

converter.addExtension({
  type: 'lang',
  regex: /#/g,
  replace: '\\#',
});

export type RenderMarkdownProps = {
  markdown?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const RenderMarkdown: FC<RenderMarkdownProps> = ({ markdown, ...attrs }) => {
  const html = useMemo(() => {
    if (!markdown) return '';

    try {
      return converter.makeHtml(markdown);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[RenderMarkdown]', markdown, error);
    }

    return markdown;
  }, [markdown]);

  return (
    <div
      className="Markdown"
      {...attrs}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RenderMarkdown;
